/* ==========================================================================
   Moonwraps - "why this cap" accordion.
   Vanilla, deferred, scoped per section instance. One row open at a time,
   height animates over 250ms, nothing animates under prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = '[data-mw-story]';
  var instances = [];

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function Accordion(root) {
    this.root = root;
    var self = this;
    this.items = Array.prototype.slice
      .call(root.querySelectorAll('[data-mw-row]'))
      .map(function (row) {
        return {
          row: row,
          btn: row.querySelector('[data-mw-row-btn]'),
          panel: row.querySelector('[data-mw-row-panel]')
        };
      })
      .filter(function (i) { return i.btn && i.panel; });

    this.onClick = function (e) {
      var btn = closest(e.target, '[data-mw-row-btn]');
      if (!btn || !root.contains(btn)) return;
      var item = self.items.filter(function (i) { return i.btn === btn; })[0];
      if (!item) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      self.openOnly(isOpen ? null : item, true);
    };

    root.addEventListener('click', this.onClick);

    // normalise to the state rendered by Liquid: the first row is open
    var initial = this.items.filter(function (i) {
      return i.btn.getAttribute('aria-expanded') === 'true';
    })[0] || this.items[0];
    this.openOnly(initial, false);
  }

  Accordion.prototype.openOnly = function (target, animate) {
    var self = this;
    this.items.forEach(function (item) {
      self.set(item, item === target, animate);
    });
  };

  Accordion.prototype.set = function (item, open, animate) {
    var panel = item.panel;
    item.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.row.classList.toggle('is-open', open);

    if (!animate || reduced()) {
      panel.style.transition = 'none';
      panel.style.height = open ? 'auto' : '0px';
      void panel.offsetHeight;
      panel.style.transition = '';
      return;
    }

    var start = panel.getBoundingClientRect().height;
    panel.style.height = start + 'px';
    void panel.offsetHeight;
    var end = open ? panel.scrollHeight : 0;
    if (start === end) {
      if (open) panel.style.height = 'auto';
      return;
    }
    panel.style.height = end + 'px';

    var done = function (e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      if (open) panel.style.height = 'auto';
    };
    panel.addEventListener('transitionend', done);
  };

  Accordion.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    delete this.root.__mwStory;
  };

  function initRoot(root) {
    if (root.__mwStory) return root.__mwStory;
    var a = new Accordion(root);
    root.__mwStory = a;
    instances.push(a);
    return a;
  }

  function initAll(scope) {
    var node = scope || document;
    if (node.matches && node.matches(ROOT)) initRoot(node);
    var found = node.querySelectorAll ? node.querySelectorAll(ROOT) : [];
    for (var i = 0; i < found.length; i++) initRoot(found[i]);
  }

  function destroyAll(scope) {
    var node = scope || document;
    var list = [];
    if (node.matches && node.matches(ROOT)) list.push(node);
    var found = node.querySelectorAll ? node.querySelectorAll(ROOT) : [];
    for (var i = 0; i < found.length; i++) list.push(found[i]);
    list.forEach(function (el) {
      var a = el.__mwStory;
      if (!a) return;
      a.destroy();
      var at = instances.indexOf(a);
      if (at > -1) instances.splice(at, 1);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    destroyAll(e.target);
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    destroyAll(e.target);
  });

  /* Theme editor: selecting a row block opens it. */
  document.addEventListener('shopify:block:select', function (e) {
    var row = closest(e.target, '[data-mw-row]');
    var root = row && closest(row, ROOT);
    var a = root && root.__mwStory;
    if (!a) return;
    var item = a.items.filter(function (i) { return i.row === row; })[0];
    if (item) a.openOnly(item, true);
  });

  initAll(document);
})();
